import { AfterViewChecked, Component, HostBinding } from '@angular/core';
import { environment } from '@environments/environment';

@Component({
  selector: 'login-base-component',
  template: ` <ng-container *ngComponentOutlet="loginContainerRef | async"></ng-container>`,
})
export class LoginBaseComponent implements AfterViewChecked {
  public loginContainerRef: Promise<any> | undefined;
  isMountedLoginComp = false;

  // todo need mapping other projects
  loginComponents = {
    p1012: () => {
      return import('@app/sharedTemplates/login/p1012/login-p1012.component').then(i => i.LoginP1012Component);
    },
  };

  @HostBinding('class.fullscreen-component') someField = true;
  ngAfterViewChecked() {
    if (!this.isMountedLoginComp) {
      this.loadLoginComponent().then();
    }
  }
  async loadLoginComponent() {
    console.log('Loading component...;');
    this.isMountedLoginComp = true;

    try {
      try {
        const componentName = environment.product;
        const component = this.loginComponents[componentName];
        if (component) {
          this.loginContainerRef = component();
        }
      } catch (e) {
        console.log(e);
      }
    } catch (e) {
      console.error('Component cannot loaded.', e);
    }

    return;
  }
}
